import { usePendingCounts } from "../api/queries/approvalQueries";
import usePermissions from "./usePermissions";

/**
 * Whether to show the Approvals menu: a role that can view DTR, attendance or
 * overtime, and is an approver per /dashboard/me (COMPANY scope in one of
 * them, or something to approve).
 */
const useApprovalAccess = () => {
  const { canAny, superAdmin, configured } = usePermissions();
  const { isApprover, validationCount, overtimeCount, correctionCount } =
    usePendingCounts({ enabled: configured });
  const pendingTotal = validationCount + overtimeCount + correctionCount;
  return {
    canSeeApprovals:
      superAdmin ||
      (canAny("dtr", "attendance", "overtime") &&
        (isApprover || pendingTotal > 0)),
    isApprover,
    correctionCount,
    overtimeCount,
    pendingTotal,
    validationCount,
  };
};

export default useApprovalAccess;
